import { EvalutaionCheckDisplay } from "./EvaluationCheck/EvaluationCheckDisplay";
import { EvaluationCounterDisplay } from "./EvaluationCounter/EvaluationCounterDisplay";
import { PersonPickerDisplay } from "./PersonPicker/PersonPickerDisplay";

export default {
    personPicker: PersonPickerDisplay,
    evaluationCheck: EvalutaionCheckDisplay,
    evaluationCounter: EvaluationCounterDisplay
} 